export const BLACK_OPENING_IDS = [
  "caroKann",
  "qgdBlack",
  "symmetricalEnglish",
  "openGame",
  "sicilianNajdorf",
  "kingsIndian",
  "frenchDefense",
  "kingsEnglish",
  "petroffDefense",
  "philidorDefense",
  "slavDefense",
  "nimzoIndian",
  "scandinavianDefense",
  "pircDefense",
  "qgaBlack",
  "twoKnights",
  "englishNf6",
  "retiBlack",
  "classicalSicilian",
  "kanSicilian",
  "berlinDefense",
  "steinitzDefense",
  "classicalRuy",
] as const;

export type BlackOpeningId = (typeof BLACK_OPENING_IDS)[number];
